import { render, staticRenderFns } from "./Emailing.vue?vue&type=template&id=e2b685c4&scoped=true&"
import script from "./Emailing.vue?vue&type=script&lang=js&"
export * from "./Emailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b685c4",
  null
  
)

export default component.exports